import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon } from "@radix-ui/react-icons"

import { cn } from "@/utils/cn"
import { Label } from "./label"
import { Col } from "../grid/col"
import { useFormikContext } from "formik"

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-[4px] border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <CheckIcon className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

interface FormikCheckboxProps {
  size?: number;
  label?: string;
  field?: any;
  name: string;
  value?: boolean;
}

export const FormikCheckbox = ({...props}: FormikCheckboxProps) => {
  const {values, setFieldValue} = useFormikContext<any>();
  const name = props.field?.name || props.name;
  const value = props.value || values[name];
  
  var component = (
      <>
          <Checkbox
            checked={props.value}
            onCheckedChange={(checked: any) => setFieldValue(name, checked)}
            aria-label={props.label}
          />
          {props.label && (
              <Label className="ml-2">{props.label}</Label>
          )}
      </>
  )

  if (props.size){
      return <Col xs={12} sm={props.size}>{component}</Col>
  }

  return component;
}

export { Checkbox }

